import React from 'react';
import { CloudOff, RefreshCw } from 'lucide-react';

export const handleClearCacheAndReload = async () => {
  try {
    if (
      typeof navigator !== 'undefined' &&
      navigator.serviceWorker &&
      typeof navigator.serviceWorker.getRegistrations === 'function'
    ) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      if (registrations && registrations.length > 0) {
        await Promise.all(registrations.map(reg => reg.unregister()));
      }
    }
    if (
      typeof window !== 'undefined' &&
      window.caches &&
      typeof window.caches.keys === 'function'
    ) {
      const cacheNames = await window.caches.keys();
      if (cacheNames && cacheNames.length > 0) {
        await Promise.all(cacheNames.map(name => window.caches.delete(name)));
      }
    }
  } catch (error) {
    console.error('Error clearing cache:', error);
  } finally {
    if (typeof window !== 'undefined' && window.location && typeof window.location.reload === 'function') {
      window.location.reload(true);
    }
  }
};

const OfflineBanner = ({ onClearCache }) => {
  const onClear = onClearCache || handleClearCacheAndReload;

  return (
    <div
      data-testid="offline-banner"
      className="bg-orange-500/90 text-white text-xs font-bold text-center py-1.5 px-3 shadow-sm z-[60] relative flex items-center justify-center gap-3"
    >
      <div className="flex items-center gap-2">
        <CloudOff className="w-4 h-4" />
        <span>Offline Mode - Showing Cached Data</span>
      </div>
      <button
        onClick={onClear}
        type="button"
        className="px-2.5 py-1 bg-orange-700/80 hover:bg-orange-800 text-white text-xs font-semibold rounded border border-orange-400/50 transition-colors flex items-center gap-1.5 cursor-pointer shadow-xs"
        title="Unregister service workers, clear browser cache, and reload page"
      >
        <RefreshCw className="w-3.5 h-3.5" />
        <span>Clear Cache & Reload</span>
      </button>
    </div>
  );
};

export default OfflineBanner;
